var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        {
          staticClass: "card-content",
          attrs: { gutter: 16, span: 24, justify: "space-between" },
        },
        _vm._l(_vm.cardOptions, function (item, index) {
          return _c(
            "el-col",
            {
              key: index,
              staticClass: "card-item",
              attrs: { lg: 6, md: 12, xl: 6 },
            },
            [
              _c("dataCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading.cardLoading,
                    expression: "loading.cardLoading",
                  },
                ],
                attrs: { active: 0, option: item },
              }),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "reportCard",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading.distributeLoading,
                      expression: "loading.distributeLoading",
                    },
                  ],
                  style: "height: " + _vm.reportHeight + ";",
                  attrs: { config: _vm.distribution.chart },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "report-info",
                      attrs: { slot: "reportInfo" },
                      slot: "reportInfo",
                    },
                    [
                      _c("div", { staticClass: "info-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("ocean-bi::sc-analysis::card-day"))
                        ),
                      ]),
                      _c("ul", [
                        _c("li", { staticClass: "info-item" }, [
                          _c("div", { staticClass: "info-desc" }, [
                            _c("span", { staticClass: "ring" }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "ocean-bi::sc-analysis::five-day-distRate"
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(_vm.distribution.data.distRate)
                              ) + "%"
                            ),
                          ]),
                        ]),
                        _c("li", { staticClass: "info-item" }, [
                          _c("div", { staticClass: "info-desc" }, [
                            _c("span", { staticClass: "ring" }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "ocean-bi::sc-analysis::day-30-subOrder"
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(
                                  _vm.distribution.data.day30OrderNum
                                )
                              )
                            ),
                          ]),
                        ]),
                        _c("li", { staticClass: "info-item" }, [
                          _c("div", { staticClass: "info-desc" }, [
                            _c("span", { staticClass: "ring" }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "ocean-bi::sc-analysis::day-5-dispatcherNum"
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(
                                  _vm.distribution.data.day5DispatcherNum
                                )
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "reportCard",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading.internetLoading,
                      expression: "loading.internetLoading",
                    },
                  ],
                  style: "height: " + _vm.reportHeight + ";",
                  attrs: { config: _vm.internetConfig.chart },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "report-info",
                      attrs: { slot: "reportInfo" },
                      slot: "reportInfo",
                    },
                    [
                      _c("div", { staticClass: "info-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("ocean-bi::sc-analysis::card-day"))
                        ),
                      ]),
                      _c("ul", [
                        _c("li", { staticClass: "info-item" }, [
                          _c("div", { staticClass: "info-desc" }, [
                            _c("span", { staticClass: "ring" }),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("ocean-bi::sc-analysis::上网率"))
                              ),
                            ]),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(
                                  _vm.internetConfig.data.internetRate
                                )
                              ) + "%"
                            ),
                          ]),
                        ]),
                        _c("li", { staticClass: "info-item" }, [
                          _c("div", { staticClass: "info-desc" }, [
                            _c("span", { staticClass: "ring" }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("ocean-bi::sc-analysis::月子订单数")
                                )
                              ),
                            ]),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(
                                  _vm.internetConfig.data.monthOrderNum
                                )
                              )
                            ),
                          ]),
                        ]),
                        _c("li", { staticClass: "info-item" }, [
                          _c("div", { staticClass: "info-desc" }, [
                            _c("span", { staticClass: "ring" }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "ocean-bi::sc-analysis::monthNetworkNum"
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(
                                  _vm.internetConfig.data.monthNetworkNum
                                )
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "reportCard",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading.receiveLoading,
                      expression: "loading.receiveLoading",
                    },
                  ],
                  style: "height: " + _vm.reportHeight + ";",
                  attrs: { config: _vm.receiveConfig.chart },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "report-info",
                      attrs: { slot: "reportInfo" },
                      slot: "reportInfo",
                    },
                    [
                      _c("div", { staticClass: "info-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("ocean-bi::sc-analysis::card-day"))
                        ),
                      ]),
                      _c("ul", [
                        _c("li", { staticClass: "info-item" }, [
                          _c("div", { staticClass: "info-desc" }, [
                            _c("span", { staticClass: "ring" }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("ocean-bi::sc-analysis::receiveRate")
                                )
                              ),
                            ]),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(
                                  _vm.receiveConfig.data.receiveRate
                                )
                              ) + "%"
                            ),
                          ]),
                        ]),
                        _c("li", { staticClass: "info-item" }, [
                          _c("div", { staticClass: "info-desc" }, [
                            _c("span", { staticClass: "ring" }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "ocean-bi::sc-analysis::day30OrderNum30diff"
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(
                                  _vm.receiveConfig.data.day30OrderNum30diff
                                )
                              )
                            ),
                          ]),
                        ]),
                        _c("li", { staticClass: "info-item" }, [
                          _c("div", { staticClass: "info-desc" }, [
                            _c("span", { staticClass: "ring" }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "ocean-bi::sc-analysis::day30Received30diff"
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$dataCheck(
                                  _vm.receiveConfig.data.day30Received30diff
                                )
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("EditReturnRate", {
        attrs: { rate: _vm.returnRate },
        on: { save: _vm.updateCard },
        model: {
          value: _vm.visible,
          callback: function ($$v) {
            _vm.visible = $$v
          },
          expression: "visible",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }